export default {
  title: 'Zaznacz wszystkie',
  type: 'object',
  properties: {
    checkAll: { type: 'boolean' }
  }
};
